import { createContext } from "react";

import { type GitpodAPI } from "@/api";

// @ts-expect-error Can't initialize context with empty object
export const GitpodAPIContext = createContext<GitpodAPI>();
